import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDocumentHelpModule } from "./learningAPI";

export interface DocumentHelpModState {
  documentHelpmodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DocumentHelpModState = {
    documentHelpmodule: [],
  status: "idle",
};

export const GetDocumentHelpModule = createAsyncThunk(
  "documentHelp/fetchDocumentHelp",
  async (data:any) => {
    const response = await fetchDocumentHelpModule(data);
    return response;
  }
);

export const documentHelpModuleSlice = createSlice({
  name: "DocumentHelp",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDocumentHelpModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDocumentHelpModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetDocumentHelpModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.documentHelpmodule = action.payload.material;
        //console.log(action.payload.material,"action.payload.material;")
        //state.documentHelpmodule = state.documentHelpmodule.concat(action.payload.material);
      });
  },
});

export const {} = documentHelpModuleSlice.actions;

export const selectDocumentHelpModule = (state: RootState) => {
  return state.DocumentHelpModule.documentHelpmodule;
};

export default documentHelpModuleSlice.reducer;
